module.exports = __webpack_public_path__ + "img/1.901205ec.png";